/* eslint-disable no-nested-ternary */
import { shallowEqual, useSelector } from "react-redux";
import { AppState } from "@Store/index";
import Button from "@Components/Button";
import useRoomTypeContext from "@Pages/PropertyPage/components/RoomTypeSection/context/useRoomTypeContext";
import styles from "../TenancyCard/TenancyCard.module.scss";
import useIsHappyFlow from "hooks/useIsHappyFlow";
import { HAPPY_FLOW_TENANCY_CTAS } from "constants/index";
import useTranslationHook from "hooks/useTranslationHook";
import wrapperHOC from "@Utils/wrapperHOC";
import useWhitelabel from "hooks/useWhitelabel";

type Props = {
  roomId: number;
  tenancy: any;
  isSoldOut: boolean;
  handleWaitlist: any;
  onBookNowClick: any;
  ctaText: string;
  link: string;
};

const TenancyCTA = ({
  roomId,
  tenancy,
  isSoldOut,
  handleWaitlist,
  onBookNowClick,
  ctaText,
  link,
}: Props) => {
  const { isHMO, isPartnered } = useRoomTypeContext();
  const { WAITLISTED } = HAPPY_FLOW_TENANCY_CTAS;

  const { isLFOneFilled, activeTenancyId } = useSelector(
    ({ leadFormModal }: AppState) => ({
      isLFOneFilled: leadFormModal.isLFOneFilled,
      activeTenancyId: leadFormModal.activeTenancyId,
    }),
    shallowEqual,
  );
  const { isWhitelabel } = useWhitelabel();
  const isHappyFlow = useIsHappyFlow();
  const { t } = useTranslationHook();

  return (
    <>
      {isSoldOut && !isHMO && isPartnered && (
        <Button
          dataTestId="property-room-type-Join-Waitlist"
          variant={isSoldOut ? "outline" : isWhitelabel ? "whiteLabel_primary" : "primary"}
          className={styles.btn}
          onClick={() => handleWaitlist(tenancy)}
          disable={ctaText === WAITLISTED}
          {...(isHappyFlow && isLFOneFilled ? { showLoader: activeTenancyId === tenancy?.id } : {})}
        >
          {t(ctaText)}
        </Button>
      )}
      {!isSoldOut && !isHMO && isPartnered && (
        <Button
          dataTestId="property-room-type-Book"
          variant={isSoldOut ? "outline" : isWhitelabel ? "whiteLabel_primary" : "primary"}
          className={styles.btn}
          onClick={() => onBookNowClick(ctaText, link)}
          {...(isHappyFlow && isLFOneFilled
            ? {
                showLoader: tenancy?.id
                  ? activeTenancyId === tenancy?.id
                  : activeTenancyId === roomId,
              }
            : {})}
        >
          {t(ctaText)}
        </Button>
      )}
    </>
  );
};

export default wrapperHOC(TenancyCTA, {
  componentName: "TenancyCTA-RoomTypeCard-RoomTypeSection-PropertyPage",
  showForChina: true,
});
